import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Input} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ToyotaComments extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, data) {
    const {claimCode} = this.props;
    this.props.updateReturnOrderValue(claimCode, data);
  }

  render() {
    const {isUserFromTDE, returnOrder, value} = this.props;

    if (isUserFromTDE && returnOrder.status === 'E') {
      return (
        <Input name='toyotaComments' value={value || ''} onChange={this.handleChange} />
      );
    }

    return value;
  }
}

const mapStateToProps = (state) => {
  return {
    'isUserFromTDE': state.session.isUserFromTDE,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
  };
};

const {updateReturnOrderValue} = Actions;

export default connect(mapStateToProps, {
  updateReturnOrderValue,
})(ToyotaComments);
